// Matches the model's column
export const BARCODE_MAX_LENGTH = 255

/** Strip what the API rejects: QR payloads can carry separators (GS1's group separator, newlines). */
export default function cleanBarcode(value: string): string {
    return value.replace(/\p{Cc}/gu, "").trim()
}
